export default __webpack_public_path__ + "static/media/Camion7.5b94d71b.png";